import { useMemo, useEffect } from 'react';
import { useRouter } from 'next/router';
import { NextSeo } from 'next-seo';
import Head from 'next/head';

const Page = ({ meta, transparentHeader, nextSeoProps, hrefLang = true, ...props }) => {
	//! Router
	const router = useRouter();

	//! Host
	const host = process.env.host;

	//! URL
	const url = useMemo(() => host + (router.locale !== 'en' ? '/' + router.locale : '') + router.asPath, [router]);

	useEffect(() => {
		window.history.scrollRestoration = 'manual';
	}, []);

	//! Title
	const title = useMemo(() => meta?.title || url, [meta?.title, url]);

	//! Description
	const description = useMemo(() => meta?.description || url, [meta?.description]);

	return (
		<>
			<NextSeo
				title={title}
				description={description}
				canonical={url}
				type='website'
				openGraph={{
					type: 'website',
					url: url,
					title: title,
					description: description,
					images: [{ url: meta?.image?.url || process.env.host + '/images/default.jpeg', alt: title }],
				}}
				twitter={{
					handle: '@handle',
					site: '@site',
					cardType: 'summary_large_image',
				}}
				{...nextSeoProps}
			/>
			{hrefLang ? (
				<Head>
					<link
						rel='alternate'
						href={`${host}${router.asPath}`}
						hrefLang='x-default'
					/>

					{router.locales.map((loc) => (
						<link
							key={loc}
							rel='alternate'
							href={`${host + (loc !== 'en' ? '/' + loc : '') + router.asPath}`}
							hrefLang={loc}
						/>
					))}
				</Head>
			) : null}
			<main className={`page ${transparentHeader ? 'dark' : ''}  ${props.className || ''}`}>
				{props.children}
			</main>
		</>
	);
};

export default Page;
